






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ type: String, default: 'middle' })
  readonly size!: string;

  @Prop({ type: String, default: 'rooms' })
  readonly type!: string;

  get classType() {
    return [`icon_${this.size}`, `icon_${this.type}`];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/icon/Icon.vue